import { RibbonLogoIcon } from "Icons/RibbonLogo";

import { css } from "@emotion/react";

import { Typography } from "components/shared/library/Typography";

import { down } from "utils/mediaQueryStrings";

import { gradient, purple, uiGray } from "constants/colors";

const style = {
  wrapper: css({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    overflow: "hidden",
    width: 948,
    height: "100%",
    borderRadius: 24,
    boxShadow: "0px 8px 8px -4px #1B1B1B08, 0px 20px 24px -4px #1B1B1B14",
    [down("mobile")]: {
      display: "flex",
      flexDirection: "column",
      borderRadius: 0,
      boxShadow: "none",
      width: "initial",
      overflow: "auto",
      paddingBottom: 100,
    },
  }),
  leftPanel: css({
    display: "flex",
    flexDirection: "column",
    background: gradient.background,
    [down("mobile")]: {
      background: purple[50],
      padding: 24,
      width: "-webkit-fill-available",
    },
    padding: 40,
    justifyContent: "space-between",
  }),
  leftPanelHeader: css({
    display: "flex",
    flexDirection: "column",
    gap: 24,
    [down("mobile")]: { marginBottom: 24 },
  }),
  rightPanel: css({
    background: "white",
    padding: 40,
    [down("mobile")]: {
      padding: 24,
      height: "100%",
      width: "-webkit-fill-available",
    },
  }),
  header: css({
    gap: 16,
    display: "flex",
    flexDirection: "column",
    maxWidth: 370,
  }),
};

type Props = {
  title: string;
  subtitle: string | React.ReactNode;
  content?: React.ReactNode;
  children: React.ReactNode;
};

export const TwoPanelCard = ({ title, subtitle, content, children }: Props) => {
  return (
    <div css={style.wrapper}>
      <div css={style.leftPanel}>
        <div css={style.leftPanelHeader}>
          <RibbonLogoIcon width={48} height={48} />
          <div css={style.header}>
            <Typography weight="bold" size="XXL" color={uiGray[100]}>
              {title}
            </Typography>
            <Typography color={uiGray[70]}>{subtitle}</Typography>
          </div>
        </div>
        {content}
      </div>
      <div css={style.rightPanel}>{children}</div>
    </div>
  );
};
